import type { ProjectItem as ProjectItemData } from 'types/bio';
import styles from './projectitem.module.scss';

interface ProjectItemProps {
  project: ProjectItemData;
}

const ProjectItem: React.FC<ProjectItemProps> = ({ project }) => {
  return (
    <div className={styles.projectItemRoot}>
      <div className={styles.title}>{project.title}</div>
      <div className={styles.status}>{project.status}</div>
    </div>
  );
};

export default ProjectItem;
